/**
 * @desc PDA入库单收货
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InMasterPDAReceivingRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/pdaReceiving`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
